import { render, staticRenderFns } from "./ExcCardTickersExchangeContainer.vue?vue&type=template&id=5f0ce54a&scoped=true&"
import script from "./ExcCardTickersExchangeContainer.vue?vue&type=script&lang=js&"
export * from "./ExcCardTickersExchangeContainer.vue?vue&type=script&lang=js&"
import style0 from "./ExcCardTickersExchangeContainer.vue?vue&type=style&index=0&id=5f0ce54a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ce54a",
  null
  
)

export default component.exports